var React = require('react');

function ChevronUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.99008 16L12.2933 11.6959L16.5965 16L18.4453 14.1512L12.2933 8L6.14124 14.1512L7.99008 16Z","fill":"#16384E"}));
}

ChevronUpInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = ChevronUpInline;

ChevronUpInline.default = ChevronUpInline;
